import { ProfileOutlineAvatar } from '@/libs/material/icons';
import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import { Box } from '@rhg/libs/material';

const styleIconWrapper = {
    width: '64px',
    height: '64px',
    '& > svg': {
        height: DS_HEIGHT.AVATAR_SMALL,
        width: DS_HEIGHT.AVATAR_SMALL,
    },
    borderRadius: '50%',
    backgroundColor: 'background.paper',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const AgeGenderFormIcon = () => (
    <Box sx={styleIconWrapper}>
        <ProfileOutlineAvatar inheritViewBox={false} viewBox="-1 -1 24 24" />
    </Box>
);
